module.exports = __webpack_public_path__ + "static/media/angle-double-left.0d9d571a.svg";